import { useRef } from "react";
import Select, { components } from "react-select";
import { has, isObject } from "lodash";

import Liststructure from "../field/List";
import classes from "./Field.module.css";

const Option = (props) => {
  return (
    <div title={props.data.tooltip}>
      <components.Option {...props} />
    </div>
  );
};

const Field = (props) => {
  const field = props.field;
  const allData = props.allData;
  const updateField = props.updateField;
  const inputEl = useRef(null);
  let mergeTagHtml = "";
  let inputContainerClasses = classes.formInputContainer;

  /**
   * Get Value of current field from state
   * @param {*} fieldId
   * @returns
   */

  const getFieldValue = (fieldId = field.id) => {
    let fieldValue = "Field Value not found";

    Object.keys(allData).forEach((categoryName) => {
      allData[categoryName].forEach((fieldData) => {
        if (fieldData.id === fieldId) {
          fieldValue = fieldData.value;
          // console.log(fieldValue);
        }
      });
    });
    return fieldValue;
  };
  /**
   * Update value of field in state
   * @param {*} value
   */
  const fieldChangeHandler = (value) => {
    //confirmation pop-up if field has confirmation message
    if (!!field.confirmationMessage) {
      //no change if confirmation is falsy
      if (!window.confirm(field.confirmationMessage)) {
        return;
      }
    }

    switch (field.type) {
      case "select":
        updateField({
          type: "FIELDUPDATE",
          data: value,
          category: field.category,
          id: field.id,
        });
        break;

      case "multiSelect":
        const multiSelectValue = value.map(
          (selectedOption) => selectedOption.value
        );
        updateField({
          type: "FIELDUPDATE",
          data: multiSelectValue,
          category: field.category,
          id: field.id,
        });
        break;
      default:
        updateField({
          type: "FIELDUPDATE",
          data: value,
          category: field.category,
          id: field.id,
        });
    }
  };

  /**
   * Whether to show field or not
   */
  if (field.conditional.length > 0) {
    // This is conditional field
    let conditionalLogicValid = true;
    field.conditional.forEach((condition) => {
      const conditionFieldId = condition.id;
      const conditionFieldValue = condition.value;
      let fieldValue = getFieldValue(conditionFieldId);

      //using isObject and has because in case of select value comparision.. fieldValue is an object
      if (isObject(fieldValue) && has(fieldValue, "value")) {
        fieldValue = fieldValue.value;
      }

      switch (condition.operator) {
        case "not":
          if (fieldValue === conditionFieldValue) {
            conditionalLogicValid = false;
          }
          break;
        default:
          if (fieldValue !== conditionFieldValue) {
            conditionalLogicValid = false;
          }
      }
    });

    if (!conditionalLogicValid) {
      return "";
    }
  }

  //updating field value at the position of cursor...when field supports mergetags
  const mergeTagHandler = (event) => {
    var valueOfInput = inputEl.current.value;
    var cursorPosition = valueOfInput.slice(0, inputEl.current.selectionStart);
    var insertedText = event.target.getAttribute("data-mergetag");
    var textAftercursor = valueOfInput.substring(cursorPosition.length);
    var inputValue = cursorPosition + insertedText + textAftercursor;
    fieldChangeHandler(inputValue);
  };

  const listOpener = (event) => {
    if (props.activeMergeFieldId === field.id) {
      props.setActiveMergeFieldId(false);
    } else {
      props.setActiveMergeFieldId(field.id);
    }
  };

  const hasMergeTagButton = () => {
    // const mergeTagsHtml = mergeTagsHtmlGenerator( field.id, mergeTagHandler, props.trigger );

    let isMergeTagActive = props.activeMergeFieldId === field.id ? true : false;
    return (
      <span className={classes.listSpan} onClick={listOpener}>
        {isMergeTagActive && (
          <Liststructure
            mergeTagHandler={mergeTagHandler}
            trigger={props.trigger}
          />
        )}{" "}
      </span>
    );
  };

  if (field.supportsMergeTags) {
    mergeTagHtml = hasMergeTagButton();
    inputContainerClasses += " " + classes.hasMergeTag;
  }

  /**
   * Output jsx of the field
   */
  switch (field.type) {
    case "text":
      return (
        <div className={classes.main}>
          <div className={classes.labelInfo}>
            <label>{field.label}</label>
          </div>
          <div className={inputContainerClasses}>
            <input
              type="text"
              {...field.attributes}
              id={field.id}
              className={classes.formInput}
              value={getFieldValue()}
              ref={inputEl}
              onChange={(e) => fieldChangeHandler(e.target.value)}
            />
            {mergeTagHtml}
          </div>
        </div>
      );
    case "checkbox":
      return (
        <div className={classes.main}>
          <div className={classes.labelInfo}>
            <label>{field.label}</label>
          </div>
          <div>
            <input
              type="checkbox"
              onChange={(e) => fieldChangeHandler(e.target.checked)}
              defaultChecked={getFieldValue()}
              checked={getFieldValue()}
            />
          </div>
        </div>
      );
    case "select":
      return (
        <div className={classes.main}>
          <div className={classes.labelInfo}>
            <label>{field.label}</label>
          </div>
          <div className={classes.formInputContainer}>
            <Select
              components={{ Option }}
              name="wpmnotifications-trigger"
              // defaultValue={getFieldValue()}
              value={getFieldValue()}
              options={field.options}
              onChange={fieldChangeHandler}
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
            />
          </div>
        </div>
      );
    case "multiSelect":
      return (
        <div className={classes.main}>
          <div className={classes.labelInfo}>
            <label>{field.label}</label>
          </div>
          <div className={classes.formInputContainer}>
            <Select
              name="wpmnotifications-trigger"
              options={field.options}
              isMulti
              onChange={fieldChangeHandler}
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
            />
          </div>
        </div>
      );
    case "hidden":
      return (
        <div className={classes.main}>
          <input type="hidden" value={getFieldValue()} />
        </div>
      );

    default:
      return "this is not text field";
  }
};

export default Field;
